import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { Anchor, DetailedIconHome, List, Spacer } from '@zillow/constellation';
import { Heading } from '@zillow/constellation-10';

import { RMWContext } from '../../../../providers/RMWContext';

const propTypes = {
  convertedListingAlias: PropTypes.string.isRequired,
  handleModalReset: PropTypes.func.isRequired,
};
const defaultProps = {};

const Congratulations = ({ convertedListingAlias, handleModalReset }) => {
  const { paths } = useContext(RMWContext);

  const pathToRoute = `${paths.propertiesPage}/${convertedListingAlias}/listing`;

  const handleNewTab = () => {
    window.router.updateLocation(pathToRoute, '_blank');
  };

  return (
    <>
      <Spacer marginBottom="md">
        <DetailedIconHome />
      </Spacer>
      <Heading level={4} fontFamily="heading-alt" css={{ marginBottom: '400' }}>
        Congratulations!
      </Heading>
      <List>
        <List.Item>
          <Anchor onClick={handleNewTab}>View your converted listing</Anchor>
        </List.Item>
        <List.Item>
          <Anchor onClick={handleModalReset}>Convert another floor plan/unit</Anchor>
        </List.Item>
      </List>
    </>
  );
};

Congratulations.defaultProps = defaultProps;
Congratulations.propTypes = propTypes;

export default Congratulations;
